import React, { useState, useEffect } from "react";
import { useFormContext, Controller, useWatch } from "react-hook-form";

const CustomSelectField = ({ attribute, inputField }) => {
  const {
    name,
    options = [],
    placeholder = "Select an option",
    ...rest
  } = attribute;

  const {
    control,
    formState: { errors },
  } = useFormContext();

  const [showInputField, setShowInputField] = useState(false);
  const [selectedValue, setSelectedValue] = useState("");
  const [inputValue, setInputValue] = useState("");
  const fieldValue = useWatch({
    control,
    name,
    defaultValue: "",
  });

  useEffect(() => {
    if (fieldValue === "") {
      setSelectedValue("");
      setInputValue("");
      setShowInputField(false);
    }
  }, [fieldValue]);

  const handleChange = (event, onChange) => {
    const { value } = event.target;
    setSelectedValue(value);
    onChange(value);
    setShowInputField(value === "Yes");
  };

  const handleInputChange = (event, onChange) => {
    const { value } = event.target;
    setInputValue(value);
    onChange(value);
  };

  const handleClearInput = (onChange) => {
    setShowInputField(false);
    setSelectedValue("");
    setInputValue("");
    onChange("");
  };

  return (
    <>
      {errors[name] && <p className="errorMesg">{errors[name].message}</p>}

      <Controller
        name={name}
        control={control}
        defaultValue=""
        rules={{ required: "This field is required" }}
        render={({ field: { onChange, value, ...field } }) => (
          <>
            {showInputField ? (
              <div style={{ position: "relative", width: "100%" }}>
                <input
                  {...field}
                  {...inputField}
                  value={inputValue}
                  onChange={(e) => handleInputChange(e, onChange)}
                  className={`form-control px-3 py-2 ${
                    errors[name] ? "error-red" : ""
                  }`}
                  aria-invalid={!!errors[name]}
                  aria-describedby={errors[name] ? `${name}-error` : undefined}
                />
                <button
                  type="button"
                  onClick={() => handleClearInput(onChange)}
                  className="close-button"
                  aria-label="Clear input"
                >
                  ×
                </button>
              </div>
            ) : (
              <select
                {...field}
                {...rest}
                value={selectedValue}
                onChange={(e) => handleChange(e, onChange)}
                className={`form-control px-3 py-2 custom-height ${
                  errors[name] ? "error-red" : ""
                }`}
                aria-invalid={!!errors[name]}
                aria-describedby={errors[name] ? `${name}-error` : undefined}
              >
                <option value="" disabled>
                  {placeholder}
                </option>
                {options.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            )}
          </>
        )}
      />
    </>
  );
};

export default CustomSelectField;
